import { UntypedFormGroup } from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderContent } from '../../../shared/login-header/models/login-header.interface';
import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface SecurityQuestionsContent {
  securityQuestionList: UlItem[];
}

export interface SecurityQuestionListApi {
  currentIndicator: string;
  questionNumber: string;
  questionText: string;
}
export interface SecurityQuestionContentApi {
  securityQuestionList: SecurityQuestionListApi[];
}

export interface AddSqaContent {
  formGroup: UntypedFormGroup;
  formAttributes: AddSqaFormAttributes;
  pageContent: AddSqaPageContent;
  hasError: boolean;
  errorMessage: string;
}

export interface AddSqaFormAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  answerOneControlTouched: boolean;
  answerTwoControlTouched: boolean;
  questionOneControlTouched: boolean;
  questionTwoControlTouched: boolean;
  disableActionButton: boolean;
}

export interface AddSqaPageContent {
  answer1Label: string;
  answer1Text: string;
  answer2Label: string;
  answer2Text: string;
  buttonLabel: string;
  contentBodyHeader: string;
  defaultSelectValue: string;
  errors: AddSqaErrorMessages;
  nextDisplayView: NextDisplayView;
  headerSubTitle: string;
  headerTitle: string;
  pageHeader: LoginHeaderContent;
  question1Label: string;
  question2Label: string;
  viewName: string;
  securityQuestionList: UlItem[];
}

export interface AddSqaErrorMessages {
  answerOneErrorMessage: {
    INVALID_FIRST_SEC_ANS: string;
    ANS_IN_USE: string;
    SEC_ANS_LESS_THAN_FOUR_CHAR: string;
  };
  answerTwoErrorMessage: {
    INVALID_SECOND_SEC_ANS: string;
    ANS_IN_USE: string;
    SEC_ANS_LESS_THAN_FOUR_CHAR: string;
  };
  questionOneErrorMessage: {
    SEL_FIRST_SEC_QUESTION: string;
  };
  questionTwoErrorMessage: {
    SEL_SECOND_SEC_QUESTION: string;
    QUESTION_IN_USE: string;
  };
  alertWarning: string;
}

export interface AddSqaFormAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  answerOneControlTouched: boolean;
  answerTwoControlTouched: boolean;
  questionOneControlTouched: boolean;
  questionTwoControlTouched: boolean;
  disableActionButton: boolean;
}

export interface ErrorOption {
  errorId: string;
  errorMessageDescription: string;
  errorMessageTitle: string;
}

export interface Error {
  code: string;
  description: string;
}

export interface FormError {
  error: string;
}

export interface RequestAddSqa {
  securityQuestionNbr1: string;
  securityQuestionNbr2: string;
  tlMaskInfo_answer1: string;
  tlMaskInfo_answer2: string;
}

export interface ResponseAddSqa {
  errors?: Error[];
  firstName?: string;
  lastName?: string;
  skymilesBalance?: string;
  refreshURL?: string;
  formNameSubmitted?: string;
  isLoggedIn: boolean;
  hasSQA?: boolean;
  hasEmail?: boolean;
  isEmailValid?: boolean;
  smNbr?: string;
  smType?: string;
  loginMethod: string;
  rememberMe?: string;
  isBusiness?: boolean;
}
